// Default
export const DEFAULT_IMG = "./assets/default/NoImagePlaceholder.png";

// Comman Images
export const ARROW_ICON = "./assets/common/arrow_icon.svg";
export const EMAIL_ICON = "./assets/common/email_icon.svg";
export const EYE_CLOSE = "./assets/common/eye_close_icon.svg";
export const EYE_OPEN = "./assets/common/eye_open_icon.svg";
export const CLINIC_ICON = "./assets/common/clinic_icon.svg";
export const FILEUPLOAD_ICON = "./assets/common/fileupload_icon.svg";
export const LOCATION_ICON = "./assets/common/location_icon.svg";
export const STARICON = "./assets/common/Star.svg";
export const STARICONBG = "./assets/common/starbg.svg";
export const SUBSCRIPTION_ICON = "./assets/common/subscriptionicon.svg";
export const RIGHTARROW_IMG = "./assets/common/rightarrowimg.png";
export const LANGUAGECHANGE = "./assets/common/langauge_icon.svg";
export const DOCTOR_DETAIL_IAMGE = "./assets/common/doctor-detail.svg";
export const LOGOUT_ICON = "./assets/common/logout.svg";
export const LOGOUT_ICONSMALL = "./assets/common/smalllogouticon.svg";
export const PROFILE_IMG = "./assets/common/profileimg.png";
export const EDIT_ICON = "./assets/common/editicon.svg";
export const PDF_IMG = "./assets/common/pdfimg.png";
export const PROFILE_ICON = "./assets/common/profileicon.svg";
export const EDIT_PROFILE_ICON = "./assets/common/editprofileicon.svg";
export const PROFILE_ICONSMALL = "./assets/common/profile_icon.svg";
export const NOAVAILABILITYADDED = "./assets/common/addavailability.png";
export const FRAMEIMG = "./assets/common/Frame.png";
export const LOACK_ICON = "./assets/common/loackicon.svg";
export const PROFILE_PICTURE = "./assets/common/profile_picture.png";
export const LOGOUT_IMG = "./assets/common/logoutimg.png";
export const MAILICON = "./assets/img/mailicon.svg";


// login page image constant
export const LOGO_ICON = "./assets/loginicon/logo-medicine.svg";
export const LOGO_IMG = "./assets/loginicon/loginbg.png";

export const LOGO_SECOND = "./assets/loginicon/logo_secound.jpg";
export const SMALL_LOGO = "./assets/loginicon/logo-medicine.svg";

export const LOGIN_BG = "./assets/loginicon/login-bg.png";
export const LOGIN_BGAR = "./assets/loginicon/login-bgar.png";
export const LOGIN_BGFR = "./assets/loginicon/login-bgfr.png";
export const REGISTER_BG = "./assets/loginicon/register-bg.png";
export const REGISTER_BGAR = "./assets/loginicon/register-bgar.png";
export const REGISTER_BGFR = "./assets/loginicon/register-bgfr.png";
export const PAGE_404 = "./assets/img/404page.svg";
export const NORECORDFOUND = "./assets/img/norecordfound.svg";

// home screen image constant
export const HEROSECTION = "./assets/home/HeroSectiondoctor.png";
export const INNOVIERLOGO = "./assets/home/innovierlogo.png";
export const INNOVIERLOGO_IMG = "./assets/home/innovierlogo2.png";
export const CROUSEL_IMG1 = "./assets/home/crouselimg1.png";
export const crousel_IMG2 = "./assets/home/crouselimg2.png";
export const MISSION_ICON = "./assets/home/missionicon.png";
export const VISION_IMG = "./assets/home/overvision.png";
export const VISION_IMGFR = "./assets/home/overvisionfr.png";
export const VISION_IMGAR = "./assets/home/overvisionar.png";

export const PHONE1 = "./assets/home/product1.png";
export const FOOD_ICON = "./assets/home/foodicon.png";
export const ABOUTIMG = "./assets/home/aboutimg.png";
export const ABOUTFRIMG = "./assets/home/aboutimgfr.png";
export const ABOUTARIMG = "./assets/home/aboutimgar.png";
export const GOOGLE_IMG = "./assets/home/googlebtn.png";
export const APPLE_IMG = "./assets/home/applebtn.png";
export const ABOUTARROW_ICON = "./assets/home/rightarrowicon.svg";
export const SAFTY_ICON = "./assets/home/saftyicon.png";
export const PRODUCTS_IMG = "./assets/home/productsimg.png";
export const PRODUCTS_IMGFR = "./assets/home/productsimgfr.png";
export const PRODUCTS_IMGAR = "./assets/home/productsimgar.png";

export const QUALITY_ICON = "./assets/home/highqualityicon.png";
export const DIGONIST_ICON = "./assets/home/digonsticproduct.png";
export const MEDICAL_ICON = "./assets/home/medicaldevice.png";
export const EYE_ICON = "./assets/home/eyeproduct.png";
export const DENTAL_ICON = "./assets/home/dentalicon.png";
export const PHONE2 = "./assets/home/product2.png";
export const PRIMIUMVISION_IMG = "./assets/home/primiyumvision.png";
export const EYEVISION_IMG = "./assets/home/eyevision.png";
export const ADVANTAL_IMG = "./assets/home/advantal.png";
export const VISSION_ICON = "./assets/home/vissionicon.png";
export const MISSION_IMG = "./assets/home/missionimg.png";
export const DOCTORTEAM = "./assets/home/Expertdoctorteam.png";
export const BLUEARROW_ICON = "./assets/home/bluearrowicon.svg";
export const ARROWLEFT = "./assets/home/ArrowCircleLeft.png";
export const ARROWRIGHT = "./assets/home/ArrowCircleRight.svg";
export const HOMEBANNERIMAGE = "./assets/home/homebannerimage.png";
export const TESTOMINALIMAGEPERSON = "./assets/home/testimonal image1.png";
export const TESTOMINALIMAGEWOMEN = "./assets/home/testimonalimage2.png";
export const FOOTERVECTOR = "./assets/home/footervector.svg";
export const FACEBOOKLOGO = "./assets/home/FacebookLogo.svg";
export const INSTAGARMLOGO = "./assets/home/InstagramLogo.svg";
export const TWITTERLOGO = "./assets/home/TwitterLogo.svg";
export const MOBILEEXPLOUR = "./assets/home/mobileexplour.png";
export const VIDEOCALLMEN = "./assets/home/videocallmobile.png";
export const CALENDERHEART = "./assets/home/CalendarHeart.svg";
export const VIDEOCONFERENCE = "./assets/home/VideoConference.svg";
export const FILTESIMG = "./assets/home/Files.svg";
export const SHIELDCHECK = "./assets/home/ShieldCheck.svg";

// table
export const SEARCH_ICN = "./assets/table/searchicon.svg";
export const RIGHTARROW_ICON = "./assets/table/RightArrowIcon.svg";
export const PLUS_ICON = "./assets/table/plusicon.svg";
export const CLOSE_ICON = "./assets/table/closeicon.svg";
export const QUESTION_IMG = "./assets/table/questionicon.svg";
export const BLUR_QUESTION = "./assets/table/blurquestion.svg";
export const QUESTIONIMG = "./assets/table/addquestionicon.svg";
export const CANCEL_ICON = "./assets/table/cancelicon.png";
export const CANCELHIDE_ICON = "./assets/table/cancelhideicon.png";
export const CALANDER_ICON = "./assets/table/calandericon.png";
export const EDIT_FEESICON = "./assets/table/editfeesicon.svg";

// USED IN TOPBAR
export const NOTIFICATION_ICON = "./assets/topbar/notification_icon.svg";
export const DOWNLOAD_IMG = "./assets/topbar/downloadicon.svg";
export const PLUSICON = "./assets/topbar/plusicon.svg";
// USED FOR SIDEBAR TOP LEFT DESIGN
export const SIDEBAR_TOP_IMAGE_1 = "./assets/sidebar/sidebar-top-1.png";
export const SIDEBAR_TOP_IMAGE_2 = "./assets/sidebar/sidebar-top-2.png";
export const SIDEBAR_TOP_LEFT_IMAGE = "./assets/sidebar/sidebar-top-left.png";

// USED IN SIDEBAR MODULES ACTIVE
export const DASHBOARD_ACTIVE = "./assets/sidebar/dashboard_active_icon.svg";
export const PATIENT_ACTIVE = "./assets/sidebar/patient_active_icon.svg";
export const ROLE_ACTIVE = "./assets/sidebar/role_active_icon.svg";
export const DOCTOR_ACTIVE = "./assets/sidebar/doctor_active_icon.svg";
export const AVAILABILITY_ACTIVE =
  "./assets/sidebar/availability_active_icon.svg";
export const APPOINTMENT_ACTIVE =
  "./assets/sidebar/appointment_active_icon.svg";
export const MATCHINGMANAGEMENT_ACTIVE =
  "./assets/sidebar/matching_active_icon.svg";
export const BANKIMAGE_ACTIVE_ACTIVE = "./assets/sidebar/bank_active_icon.svg";
export const PAYMENT_ACTIVE_ = "./assets/sidebar/payment_active.svg";

// USED IN SIDEBAR MODULES NOT ACTIVE
export const DASHBOARD_NOT_ACTIVE = "./assets/sidebar/dashbaord_not_active.svg";
export const ROLE_NOT_ACTIVE = "./assets/sidebar/role_not_active_icon.svg";
export const PATIENT_NOT_ACTIVE = "./assets/sidebar/patient_not_active.svg";
export const DOCTOR_NOT_ACTIVE = "./assets/sidebar/doctor_not_active.svg";
export const AVAILABILITY_NOT_ACTIVE =
  "./assets/sidebar/availability_not_active.svg";
export const APPOINTMENT_NOT_ACTIVE =
  "./assets/sidebar/appointment_not_active.svg";
export const MATCHINGMANAGEMENT_NOT_ACTIVE =
  "./assets/sidebar/matching_not_active_icon.svg";
export const BANKIMAGE_NOT_ACTIVE = "./assets/sidebar/bank_not_icon.svg";
export const PAYMENT_NOT_ACTIVE = "./assets/sidebar/payment_not_active.svg";

// USED IN DASHBOARD
export const DASHBOARD_HERO_IMAGE6 = "./assets/dashboard/drimage.png";
export const PROFIT_IMAGE = "./assets/dashboard/profit.svg";
export const LOSS_IMAGE = "./assets/dashboard/loss.svg";
export const EXPERIANCE_ICON = "./assets/dashboard/experianceicon.svg";
export const ARROW_DOWN = "./assets/dashboard/arrow-down.svg";
export const ARROW_LEFT = "./assets/dashboard/left-arrow-icon.svg";
export const ARROW_RIGHT = "./assets/dashboard/right-arrow-icon.svg";

// availability table
export const CHECK_ICON = "./assets/availability/checkicon.svg";
export const BLOCK_ICON = "./assets/availability/blockicon.svg";
export const CLOCK_VECTOR = "./assets/availability/clockimg.svg";
export const SQUARE_PLUS_ICON = "./assets/availability/plusimg.svg";
export const DELETE_ICON = "./assets/availability/deleteimg.svg";

// USED IN table appointment
export const CALL_ICON = "./assets/appointmenticon/callicon.svg";
export const VIDEO_ICON = "./assets/appointmenticon/videoicon.svg";
export const CHATE_ICON = "./assets/appointmenticon/chateicon.svg";
export const LOCATIONSHARE_ICON = "./assets/appointmenticon/locationicon.svg";
export const VERIFYACCCOUNT_IMG = "./assets/appointmenticon/verifyAccount.png";
export const CONTACTINFO_IMG = "./assets/appointmenticon/ContactInfo.png";
export const PROFILE_REJECTED = "./assets/appointmenticon/rejected_profile.png";

// add fees icon for doctor
export const ADDFEESICON = "./assets/dashboard/addFeesIcon.png";
export const PRESCRIPTION = "./assets/dashboard/prescription_dark.png";
export const PRESCRIPTIONLIGHT = "./assets/dashboard/prescription_light.png";
export const DETAILEHIDE = "./assets/dashboard/detailehide.png";
export const MYMATCHINGICONFORTable = "./assets/dashboard/Frame.svg";
export const MATCHINGBLURICON="./assets/dashboard/Frameblur.svg"
export const DOWNLOAD_ICONSMALL = "./assets/appointmenticon/downloadicon.svg";
export const STAR_ICON = "./assets/dashboard/staricon.png";
export const GOLDSTAR_ICON = "./assets/dashboard/goldstar.svg";
export const GREYSTAR_ICON = "./assets/dashboard/greystar.svg";
export const RATING_PROFILE = "./assets/dashboard/ratingprofile.png";

// availability image
export const RESTOREBLOCKAVAILABILITY =
  "./assets/dashboard/restore_blockavailability.png";
export const LIGHTRESTOREBLOCKAVAILABILITY =
  "./assets/dashboard/restore_blockavailability_light.png";
export const BLOCKAVAILABILITYSUCCESS = "./assets/dashboard/block_success.png";
// notification icons
export const PAYMENT_ICON = "./assets/notificationicon/paymenticon.png";
//contact iimg
export const CALLCONTACT = "./assets/home/callimg.svg";
export const MAILCONTACT = "./assets/home/mailimg.svg";

// role images

export const ROLE_EDIT_ICON = "./assets/common/role-icons/roleediticon.svg";
export const ROLE_VIEW_ICON = "./assets/common/role-icons/roleviewicon.svg";

export const RESTOREICON = "./assets/common/restoreicon.png";
export const ROLEMANAGEMENT_ACTIVE = "./assets/common/rolemanagment.png";
export const ROLE_MANAGEMENT_INACTIVE =
  "./assets/common/rolemanagment-blur.png";

export const BLUESTATUS = "./assets/common/role-icons/rolestatusicon.svg";
export const GREYSTATUS = "./assets/common/role-icons/blur_rolestatusicon.svg";

export const BLUEEDIT_ICON = "./assets/common/role-icons/roleediticon.svg";
export const GREYEDIT_ICON =
  "./assets/common/role-icons/blur_roleediticon.svg ";

export const BLUEPLUSICON_ICON = "./assets/common/role-icons/roleplusicon.svg";
export const GREYPLUSICON_ICON =
  "./assets/common/role-icons/blur_roleaddicon.svg";

export const GREYEYE_ICONIMG =
  "./assets/common/role-icons/blur_roleviewicon.svg";
export const BLUEEYE_ICONIMG = "./assets/common/role-icons/roleviewicon.svg";

export const ACCESS_IMAGE_PERMISSION = "./assets/common/Accessimage.svg";
